<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">공지사항</span>
            <span class="txt">센터 admin에 보여질 공지사항을 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!noticeList"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="careAuth == true" class="com-btn blue" to="/madmin/notice/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 1000px" />
                    <col style="width: 205px" />
                    <col style="width: 205px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>등록일</th>
                        <th>제목</th>
                        <th>글쓴이</th>
                        <th>조회수</th>
                    </tr>
                </thead>
                <tbody>
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <router-link to="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="ic">공지사항</span>-->
                    <!--                                <span class="txt red new">상단 공지글입니다.</span>-->
                    <!--                            </router-link>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <tr v-for="(notice, index) in noticeList" :key="index">
                        <td>{{ notice.c_cre_dt | timestampFilter }}</td>
                        <td>
                            <router-link :to="`/madmin/notice/detail/${notice.c_id}`" class="ic-link">
                                <span class="ic">{{ notice.c_cate_nm }}</span>
                                <span
                                    :class="{
                                        txt: true,
                                        red: notice.c_top_fix_yn === true,
                                        new: notice.c_read_yn !== true,
                                    }"
                                >
                                    {{ notice.c_title }}
                                </span>
                            </router-link>
                        </td>
                        <td>{{ notice.c_staff_name ? notice.c_staff_name : '핏투데이케어' }}</td>
                        <td>{{ notice.c_view_cnt }}</td>
                    </tr>
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <router-link to="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="ic">업데이트</span>-->
                    <!--                                <span class="txt">핏투데이케어 사용자 설문조사에 참여해주세요</span>-->
                    <!--                            </router-link>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <router-link to="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="lock"><span class="blind">잠금</span></span>-->
                    <!--                                <span class="txt reply">핏투데이케어 사용자 설문조사에 참여해주세요 마니마니 참여해주세요 감사합니다 하나둘셋넷다섯여섯 감사합니다</span>-->
                    <!--                            </router-link>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <!--                    <tr>-->
                    <!--                        <td>2019-07-17</td>-->
                    <!--                        <td>-->
                    <!--                            <router-link to="/madmin/notice/detail" class="ic-link">-->
                    <!--                                <span class="lock"><span class="blind">잠금</span></span>-->
                    <!--                                <span class="ic">업데이트</span>-->
                    <!--                                <span class="txt new reply">핏투데이케어 사용자 설문조사에 참여해주세요 마니마니 참여해주세요 감사합니다 하나둘셋넷다섯여섯 감사합니다</span>-->
                    <!--                            </router-link>-->
                    <!--                        </td>-->
                    <!--                        <td>핏투데이케어</td>-->
                    <!--                        <td>100</td>-->
                    <!--                    </tr>-->
                    <tr v-if="noticeList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="careAuth == true" class="com-btn blue" to="/madmin/notice/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { calcNewPost } from '@/assets/js/validation.js';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'noticeList',
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
    },
    // keepAlive 라우트라 수정·등록·삭제 후 돌아오면 mounted가 다시 돌지 않는다. 진입할 때마다 activated에서 조회한다.
    activated() {
        this.fetchNoticeList();
    },
    data() {
        return {
            careAuth: false,
            noticeList: null,
            pagingInfo: { ...pagingInfo },
        };
    },
    methods: {
        // 최근 게시글(N) 표시 위한 날짜 계산, true면 새 게시글
        newPost(creDt) {
            return calcNewPost(creDt);
        },

        // 공지사항 목록 Fetch
        async fetchNoticeList() {
            try {
                const { data } = await this.getNoticeList();
                console.log('===> Success Load noticeList : ', data);
                this.setPageParams(data);
                this.noticeList = data.items;
            } catch (error) {
                console.log(error);
            }
        },

        // 공지사항 목록 조회 API 호출
        getNoticeList() {
            this.pagingInfo.limit = 10;
            // 스웨거 검색: FT공지사항 검색
            return api.get('/admin/api/ft/board/notice', {
                params: {
                    ...this.pagingInfo,
                    showType: this.careAuth ? '' : 'A',
                    // centerId: 0,
                },
            });
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchNoticeList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
    },
};
</script>
<style lang="scss"></style>
